import { TimeOffCategoryPolicySchema } from "@/pages/settings/time-off/policy/TimeOffCategoryPolicyEdit.tsx";
import {
  ApiTimeOffCountDaysType,
  ApiTimeOffDayAmountType,
  ApiTimeOffPeriodTrackingTime,
} from "@/types/time-off/time-off-policy.types.ts";
import { Box, Radio, Stack, Title } from "@skailer-com/uikit";
import { Controller, UseFormReturn } from "react-hook-form";
import { useTranslation } from "react-i18next";

export interface TimeOffPolicyCountDaysProps {
  formHook: UseFormReturn<TimeOffCategoryPolicySchema>;
  periodTrackType?: ApiTimeOffPeriodTrackingTime;
}

export function TimeOffPolicyCountDays({ formHook, periodTrackType }: TimeOffPolicyCountDaysProps) {
  const { t } = useTranslation();
  const { control, watch } = formHook;

  const countDaysType = watch("count_days_type");
  const showDayAmountType =
    countDaysType === ApiTimeOffCountDaysType.working_days &&
    periodTrackType === ApiTimeOffPeriodTrackingTime.days;

  return (
    <Stack>
      <Title
        header={t("time_off:count_days_types_title")}
        caption={t("time_off:count_days_types_description")}
        size={"xs"}
        paddingBottom
      />
      <Box variant={"border"}>
        <Controller
          render={({ field: { value, onChange } }) => (
            <>
              <Radio
                value={ApiTimeOffCountDaysType.working_days}
                checked={value == ApiTimeOffCountDaysType.working_days}
                onChange={() => {
                  onChange(ApiTimeOffCountDaysType.working_days);
                }}
                title={t("core:working_days")}
                caption={t("time_off:count_days_types_working_days_description")}
              />
              <Radio
                value={ApiTimeOffCountDaysType.calendar_days}
                checked={value == ApiTimeOffCountDaysType.calendar_days}
                onChange={() => {
                  onChange(ApiTimeOffCountDaysType.calendar_days);
                }}
                title={t("core:calendar_days")}
                caption={t("time_off:count_days_types_calendar_days_description")}
              />
            </>
          )}
          control={control}
          name={"count_days_type"}
        />
      </Box>

      {showDayAmountType && (
        <>
          <Title
            header={t("time_off:day_amount_type_title")}
            caption={t("time_off:day_amount_type_description")}
            size={"xs"}
            paddingBottom
            paddingTop
          />
          <Box variant={"border"}>
            <Controller
              render={({ field: { value, onChange } }) => (
                <>
                  <Radio
                    value={ApiTimeOffDayAmountType.full_day}
                    checked={value == ApiTimeOffDayAmountType.full_day}
                    onChange={() => {
                      onChange(ApiTimeOffDayAmountType.full_day);
                    }}
                    title={t("time_off:day_amount_type_full_day_title")}
                    caption={t("time_off:day_amount_type_full_day_description")}
                  />
                  <Radio
                    value={ApiTimeOffDayAmountType.work_pattern_share}
                    checked={value == ApiTimeOffDayAmountType.work_pattern_share}
                    onChange={() => {
                      onChange(ApiTimeOffDayAmountType.work_pattern_share);
                    }}
                    title={t("time_off:day_amount_type_work_pattern_share_title")}
                    caption={t("time_off:day_amount_type_work_pattern_share_description")}
                  />
                </>
              )}
              control={control}
              name={"day_amount_type"}
            />
          </Box>
        </>
      )}
    </Stack>
  );
}
